import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";



export const DefaultPrinterSlice = createSlice({
  name: "DefaultPrinterSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    DefaultPrinter: (state) => {
      state.isLoading = true;
    },
    successDefaultPrinter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDefaultPrinter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDefaultPrinter: (state) => {
      state.data = {};
    },
  },
});

export const {
  DefaultPrinter,
  successDefaultPrinter,
  failureDefaultPrinter,
  clearDefaultPrinter,
} = DefaultPrinterSlice.actions;

export default DefaultPrinterSlice.reducer;
